import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import * as greek from '../config/gr.json'
import * as english from '../config/en.json'

export type Languages = 'gr' | 'en'

export class I18nService {
  public init(language: Languages): void {
    i18n.use(initReactI18next).init({
      resources: {
        gr: {
          translation: greek,
        },
        en: {
          translation: english,
        },
      },
      lng: language, // Set the initial language here
      fallbackLng: language, // Specify the default language for missing translations
      interpolation: {
        escapeValue: false,
      },
    })
  }

  public switchLanguage(language: Languages): void {
    i18n.changeLanguage(language)
  }

  public getCurrentLanguage(): string {
    return i18n.language
  }
}
